import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {DateSelectorRange, DeleteModal, SelectMain, SimpleTabs} from "components";
import {AddNotes, MainDetails, Notes} from "fragments";
import {patientDetails, PatientTypesList} from "./constants";
import {useModal, usePrimaryModal} from "utils";
import {patientsActions} from "store";
import {Svg} from "assets";
import {PatientTrips} from "./fragments";

const tabsLabels = [{label: "Details"}, {label: "Notes"}, {label: "Trips"}];

const ACTION_DELETE = "DELETE_PATIENT";

export const PatientSingle = ({item, afterSuccess}) => {
    const [tripFilters, setTripFilters] = useState({});
    const {notesList} = useSelector((state) => ({
        notesList: state.notes.notesList,
    }));
    const {control, watch, setValue} = useForm();
    const dispatch = useDispatch();
    const {close} = useModal();
    const {openPrimary, closePrimary} = usePrimaryModal();


    useEffect(() => {
        if (item?.status) {
            setValue('status', item?.status)
        }
    }, [item?.status]);

    const handleGetDates = (dates) => {
        setTripFilters(dates);
    }

    const payerDetailsTabContent = [
        {
            tabComponent: <MainDetails info={patientDetails(item)}/>,
            tab: "Details",
        },

        {
            tabComponent: <Notes currentId={item?.id} onResource="patient"/>,
            tab: "Notes",
        },

        {
            tabComponent: <PatientTrips currentId={item?.id} filters={tripFilters}/>,
            tab: "Trips",
        },
    ];

    const changeStatus = (status) => {
        dispatch(patientsActions.changeStatus(item?.id, {status}))
    }

    const handleDelete = () => {
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(patientsActions.deletePatient(item?.id));
                }}
                handleCancel={closePrimary}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.firstName} ?`}
                afterSuccess={() => {
                    close();
                    closePrimary();
                    afterSuccess()
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleAddNote = () => {
        openPrimary(<AddNotes onResource="patient" currentId={item?.id}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276
        });
    };

    const handelTextButton = (currentTab) => {
        return currentTab === "Notes" && notesList?.length ? "Add Note" : "";
    };

    const handleAdd = (currentNote) => {
        return currentNote === "Notes" && handleAddNote;
    };

    return (
        <div className="patients-single-wrapper">
            <div className="modal-header-main">
                <h2 className="modal-header-title">{item?.firstName}</h2>

                <div className="align-center" style={{gap: 8}}>
                    <div style={{minWidth: 145}}>
                        <SelectMain
                            list={PatientTypesList}
                            renderLabel={(option) => option.name}
                            name='status'
                            control={control}
                            placeholder="Status"
                            selectedValue={'id'}
                            allowError={false}
                            disableClearable
                            handleChange={changeStatus}
                        />
                    </div>

                    <button className="reset-btn" onClick={handleDelete}>
                        <Svg.TrashSvg/>
                    </button>

                    <button
                        className="modal-close-btn-main"
                        type="button"
                        onClick={close}
                    >
                        <Svg.CloseSvg/>
                    </button>
                </div>
            </div>

            <div className="modal-body-main" style={{maxHeight: '70vh'}}>
                <SimpleTabs
                    tabsLabels={tabsLabels}
                    tabsContent={payerDetailsTabContent}
                    defaultTab="Details"
                    pushToHistory={false}
                    handelTextButton={handelTextButton}
                    handleAdd={handleAdd}
                    headerComponent={(value) => (value === 'Trips' &&
                        <DateSelectorRange
                            startName={'from'}
                            endName={'to'}
                            handleGetDates={handleGetDates}
                        />
                    )}
                />
            </div>
        </div>
    );
};
